// オブジェクトのプロパティを再帰的にマージする
// プロパティの値が配列だった場合の挙動:
// 　・結合（concat）せず新しい値で上書きされる
// 　・配列を結合(concat)したい場合は{concatArray: true}のオプションを渡す
// 　　例. mergeDeeply(a, b, {concatArray: true});
export const mergeDeeply = (target, source, opts) => {
  const isObject = (obj) =>
    obj && typeof obj === "object" && !Array.isArray(obj);
  const isConcatArray = opts && opts.concatArray;
  let result = Object.assign({}, target);
  if (isObject(target) && isObject(source)) {
    for (const [sourceKey, sourceValue] of Object.entries(source)) {
      const targetValue = target[sourceKey];
      if (
        isConcatArray &&
        Array.isArray(sourceValue) &&
        Array.isArray(targetValue)
      ) {
        result[sourceKey] = targetValue.concat(...sourceValue);
      } else if (
        isObject(sourceValue) &&
        target.hasOwnProperty(sourceKey) &&
        target[sourceKey] !== null
      ) {
        result[sourceKey] = mergeDeeply(targetValue, sourceValue, opts);
      } else {
        Object.assign(result, { [sourceKey]: sourceValue });
      }
    }
  }
  return result;
};
